import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react'
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { fetchProgramById, updateProgram } from '../../api/programmation';
import DynamicForm from '../../components/DynamicForm';
import DatePicker from 'react-date-picker';
import { adminProgrammeDetailsLink, adminProgrammeLink } from '../../constants/endspoints';
import { BASE_URL_EMISSION_Manage } from '../../api/emission';
import { toast } from 'react-toastify';

const ProgrammationEdit = () => {

    const {id:programId} = useParams()

    const queryClient = useQueryClient();

    const navigate = useNavigate()

    // Fetch a single program by ID
    const { data: singleProgram, isLoading: isFetchingSingle } = useQuery({
        queryKey: ['programU', programId],
        queryFn: () => fetchProgramById(programId),
        enabled: !!programId,
    });

    const [values, setValues] = useState([])
    const [dayAt, setDayAt] = useState()


    useEffect(() => {
        if (singleProgram) {
            setDayAt(new Date(singleProgram?.data?.dayAt))
        }
    }, [singleProgram]);




    // Update program
    const toastId = useRef(null);
    const updateMutation = useMutation({
        mutationFn: (data)=> updateProgram(data.id, data.formData),
        onMutate: ()=>{
            toastId.current = toast.loading("Modification en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastId.current)
            toastId.current = toast.success("Programmation modifiée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries(['program']);
            setDayAt()
            setValues()
            navigate(adminProgrammeDetailsLink+'/'+programId, {replace: true})
        },
        onError: (err) =>{
            toast.dismiss(toastId.current)
            toastId.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
        }
    });


    const submit = () => {
        const isFilled = values.every(value => value !== null && value !== undefined && value !== "")
        if (!dayAt || !isFilled) {
            alert("Renseigner tout les champs")
            return
        }
        const formattedDayAt = new Date(dayAt).toLocaleDateString('fr-CA');
        const formattedValues = values.map(id => `${BASE_URL_EMISSION_Manage}/${id}`);
        updateMutation.mutate({id: singleProgram?.data?.id, formData:{emissions:formattedValues, dayAt:formattedDayAt}})
    }

    return (
        <div>
        <h1 className='fs-3 fw-bold mb-3'> <NavLink className={'fs-3 fw-bold text-white'} to={adminProgrammeLink}>Programmation</NavLink> / Modification</h1>

        <div className='bg-black rounded-3 p-2 shadow'>
            <h2 className='fs-5 fw-bold mb-3'>Modier une programmation</h2>
                <form className='mt-3 row justify-content-between align-items-center'>

                    {
                        isFetchingSingle?
                        <p className=' text-center'>chargement...</p>
                        :
                        <>
                            <div className='col-12 mt-3'>
                                <label className='fs-8s color-primary d-block'>Jour</label>
                                <DatePicker 
                                    onChange={(e)=>setDayAt(e)} 
                                    value={dayAt} 
                                    calendarIcon={<i className="fa-thin fa-calendar text-white"></i>}
                                    clearIcon={<i className="fa-light fa-xmark text-white"></i>}
                                    minDate={new Date()}
                                    className="w-100" 
                                />
                            </div>

                            <div className='col-12 mt-3'>
                                <label className='fs-8s color-primary d-block'>Liste des émissions</label>
                                {
                                    singleProgram?.data?.emissions &&
                                    <DynamicForm setValues={setValues} initialValues={singleProgram?.data?.emissions} />
                                }
                            </div>

                            <div className=' d-flex align-items-center mt-3'>
                                <div 
                                    role='button'
                                    onClick={()=>submit()}
                                    className=' d-flex align-items-center px-2 py-1 border bordercolor-primary bgcolor-primary rounded-2 submit'
                                    disabled={updateMutation.isPending}
                                >
                                    <i className='fa-light fa-pen-to-square fs-9s me-2'></i>
                                    <span className='fs-9s'>{updateMutation.isPending? "Patientez...": "Modifier"}</span>
                                </div>
                            </div>
                        </>
                    }

                </form>
        </div>
    </div>
    )
}

export default ProgrammationEdit